import { createRouter, createWebHashHistory } from "vue-router";
import { isSignedIn } from "../functions/session";
import { useSettingsStore } from "../stores/settingsStore";
import AboutView from "../views/AboutView.vue";
import AdminSignIn from "../views/AdminSignIn.vue";
import BiobankReport from "../views/BiobankReport.vue";
import CollectionReport from "../views/CollectionReport.vue";
import ConfigurationScreen from "../views/ConfigurationScreen.vue";
import HomeView from "../views/HomeView.vue";
import Landingpage from "../views/Landingpage.vue";
import NetworkReport from "../views/NetworkReport.vue";
import ServiceReport from "../views/ServiceReport.vue";
import StudyReport from "../views/StudyReport.vue";

/** collections/studies routes only exist in the collections-era datamodel */
async function requireCollectionsView(_to, _from, next) {
  const settingsStore = useSettingsStore();
  await settingsStore.initializeConfig();
  if (settingsStore.collectionsViewEnabled) {
    next();
  } else {
    next("/catalogue");
  }
}

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/catalogue",
      name: "catalogue",
      component: HomeView,
    },
    {
      path: "/about",
      name: "about",
      component: AboutView,
    },
    {
      path: "/collection/:id",
      name: "collectiondetails",
      component: CollectionReport,
      beforeEnter: requireCollectionsView,
    },
    {
      path: "/service/:id",
      name: "servicedetails",
      component: ServiceReport,
    },
    {
      path: "/biobank/:id",
      name: "biobankdetails",
      component: BiobankReport,
    },
    { path: "/network/:id", name: "networkdetails", component: NetworkReport },
    {
      path: "/study/:id",
      name: "studydetails",
      component: StudyReport,
      beforeEnter: requireCollectionsView,
    },
    {
      /* The catalogue needs no account, so the navbar's Sign in button is
       * hidden (issue #28). This is where an administrator signs in instead;
       * it is deliberately unguarded. */
      path: "/signin",
      name: "signin",
      component: AdminSignIn,
      beforeEnter: async (_to, _from, next) => {
        const settingsStore = useSettingsStore();
        await settingsStore.sessionReady();
        if (settingsStore.showSettings) {
          next("/configuration");
        } else {
          next();
        }
      },
    },
    {
      path: "/configuration",
      component: ConfigurationScreen,
      beforeEnter: async (_to, _from, next) => {
        const settingsStore = useSettingsStore();
        /* The session arrives from the navbar after the router starts, so a
         * deep link or a reload has to wait for it - see sessionReady(). */
        await settingsStore.sessionReady();
        if (settingsStore.showSettings) {
          next();
        } else if (isSignedIn(settingsStore.session)) {
          /* Signed in without the Manager role: nothing to configure. */
          next("/");
        } else {
          next("/signin");
        }
      },
    },
    {
      path: "/",
      component: Landingpage,
      beforeEnter: async (to, _from, next) => {
        const settingsStore = useSettingsStore();
        await settingsStore.initializeConfig();
        if (
          settingsStore.config.landingpage.enabled &&
          !Object.keys(to.query).length
        ) {
          next();
        } else {
          next({ path: "/catalogue", query: to.query });
        }
      },
    },
  ],
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
